import { useToast } from 'vue-toastification'

import {
  editDocumentType,
  createDocumentType,
  getDocumentType,
  getDocumentsTypes,
  deleteDocumentType
} from '@/services/documents/index'

const toast = useToast()

export default {
  namespaced: true,
  state: () => ({
    documentType: null,
    documentsTypes: [],
    loading: false,
    totalPages: null,
    totalContent: null,
    page: 1
  }),
  mutations: {
    setLoading(state, value) {
      state.loading = value
    },
    setDocumentType(state, documentType) {
      state.documentType = documentType // Corrigido: document => documentType
    },
    setDocumentsTypes(state, documentsTypes) {
      state.documentsTypes = documentsTypes // Corrigido: documents => documentsTypes
    },
    setTotalPages(state, totalPages) {
      state.totalPages = totalPages
    },
    setTotalContent(state, totalContent) {
      state.totalContent = totalContent
    },
    setPage(state, page) {
      state.page = page
    }
  },
  actions: {
    async editDocumentType({ commit, dispatch, state }, docData) {
      commit('setLoading', true)
      return editDocumentType(docData, state.documentType?.id) // Corrigido: state.document?.id => state.documentType?.id
        .then(() => {
          toast.success('Tipo do documento atualizado com sucesso', {
            timeout: 8000
          })
          dispatch('fetchDocumentsTypes')
        })
        .catch(() => {
          toast.warning(
            'Não foi possível editar os dados do tipo do Documento',
            {
              timeout: 8000
            }
          )
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    async fetchDocumentType({ commit }, documentId) {
      commit('setLoading', true)
      return getDocumentType(documentId)
        .then((response) => {
          commit('setDocumentType', response?.data)
        })
        .catch(() => {
          toast.warning('Erro ao buscar os dados do tipo do documento', {
            timeout: 8000
          })
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    async fetchDocumentsTypes({ commit, state }, documentType) {
      commit('setLoading', true)

      const params = {
        page: state.page ?? 0,
        documentId: documentType ?? null,
        size: 10
      }

      return getDocumentsTypes({ params })
        .then((response) => {
          commit('setDocumentsTypes', response.data.content)
          commit('setTotalPages', response.data.totalPages)
          commit('setTotalContent', response.data.totalElements)
        })
        .catch(() => {
          toast.warning('Erro ao buscar os tipos de documento', {
            timeout: 8000
          })
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    updatePage({ commit }, page) {
      commit('setPage', page)
    },
    async createDocumentType({ commit, dispatch }, DocData) {
      commit('setLoading', true)
      return createDocumentType(DocData)
        .then(() => {
          toast.success('Tipo de Documento criado com sucesso')
          dispatch('fetchDocumentsTypes')
        })
        .catch(() => {
          toast.warning('Erro ao criar o tipo de documento', {
            timeout: 8000
          })
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    async deleteDocumentType({ commit, dispatch }, documentId) {
      commit('setLoading', true)
      return deleteDocumentType(documentId)
        .then(() => {
          toast.success('Tipo de documento deletado com sucesso')
          dispatch('fetchDocumentsTypes')
        })
        .catch((error) => {
          if (error.response.data.message === 'cant_delete_document_found') {
            toast.warning(
              'Não é possível excluir o tipo de documento enquanto houver documentos associados.',
              {
                timeout: 8000
              }
            )
          } else {
            toast.warning('Erro ao deletar tipo de documento', {
              timeout: 8000
            })
          }
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    clearDocumentType({ commit }) {
      commit('setLoading', true)
      commit('setDocumentType', null)
      commit('setLoading', false)
    }
  },
  getters: {
    getLoadingDocument: (state) => state.loading,
    getDocumentType: (state) => state.documentType, // Corrigido: document => documentType
    getDocumentsTypes: (state) => state.documentsTypes, // Corrigido: documents => documentsTypes
    getTotalPages: (state) => state.totalPages,
    getTotalContent: (state) => state.totalContent,
    getPage: (state) => state.page
  }
}
